<template>
  <div :id="loadingPage" class="vs-con-loading__container">
    <mail-server-filter name="mail-server-filter" v-model="filters" @search="search" />
    <div class="flex mb-4">
      <div class="w-full">
        <StatusCards @click="updateStatusFilter" :data="cards" />
      </div>
    </div>
    <div class="flex mb-4">
      <div class="w-full">
        <vs-card>
          <MailServerTable
            :data="data"
            @loadMore="loadMore"
            @search="search"
            @openFilter="openFilter"
          />
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import StatusCards from './components/StatusCards.vue'
import MailServerTable from './components/MailServerTable.vue'
import MailServerFilter from './components/MailServerFilter.vue'
import mail_server from '@/http/requests/mail_server.js'
import cards from './components/DefaultCards.js'
import loading from '@/mixins/Loading'
export default {
  components: {
    StatusCards,
    MailServerTable,
    MailServerFilter,
  },
  data() {
    return {
      data: [],
      cards: cards,
      lastPage: 1,
      params: {
        search: '',
        page: 1,
        statusId: 0,
        //sortBy: ['mail_server_logs.mail_date'],
        //sort: ['DESC'],
      },
      filters: {
        vendors: [],
        startDate: '',
        endDate: '',
      },
      loadingPage: 'mail-server-loading',
      loading: {
        data: false,
        cards: false,
      },
    }
  },
  computed: {
    isLoading() {
      return this.loading.data || this.loading.cards
    },
  },
  methods: {
    getData(){
      this.filters.startDate = this.filters.startDate.length < 10 ? '' : this.filters.startDate
      this.filters.endDate = this.filters.endDate.length < 10 ? '' : this.filters.endDate
      let payload = {...this.params,...this.filters}
      Object.keys(payload).forEach((k) => (payload[k] === null || payload[k] === '') && delete payload[k]);
      this.getTable(payload)
      this.getStatusCards(payload)
    },
    getTable(payload) {
      this.loading.data = true
      mail_server
        .list(payload)
        .then((res) => {
          if (this.params.page === 1) {
            this.data = [...res.data.result]
          } else {
            this.data = [...this.data, ...res.data.result]
          }
          this.lastPage = res.data.meta.last_page
          this.loading.data = false
        })
        .catch(res => {
          this.loading.data = false
          this.$vs.notify({
            color: 'danger',
            title: 'Attention',
            text: 'Server Error',
          })
        })
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    updateStatusFilter(e) {
      this.params.statusId = e
      this.search()
    },
    search(text = '') {
      this.params.search = text
      this.params.page = 1
      this.getData()
    },
    getStatusCards(payload) {
      this.loading.cards = true
      // delete payload.page
      // delete payload.statusId
      mail_server
        .getStatusList(payload)
        .then((res) => {
          let all = Object.assign(
            {},
            {
              id: 0,
              name: 'Mail',
              name_esp: 'correos',
              icon: 'MailIcon',
              color: '#9B59B6',
              total: res.data.total,
            }
          )
          this.cards = [all, ...res.data.statusList]
          this.loading.cards = false
        })
        .catch((res) => {
          this.loading.cards = false
          this.$vs.notify({
            color: 'danger',
            title: 'Attention',
            text: 'Server Error',
          })
        })
    },
    openFilter() {
      this.$store.dispatch('toggleSidebar', 'mail-server-filter')
    },
  },
  mixins: [loading],
  mounted() {
    this.getData()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(this.loadingPage)
      } else {
        this.closeLoading(this.loadingPage)
      }
    },
  }
}
</script>
